export const ERROR_MESSAGES = Object.freeze({
  NOT_FOUND: 'The requested resource was not found.',
  NETWORK_ERROR: 'Something went wrong. Please try again.',
  GENERIC: 'An unexpected error occurred. Please try again.',
  UNAUTHORIZED: 'You do not have permission to access this page.'
});
